import React from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';

import OrderViewInformationGeneral from './OrderViewInformationGeneral';
import OrderViewInformationVitals from './OrderViewInformationVitals';
import OrderViewInformationPrescriber from './OrderViewInformationPrescriber';
import OrderViewInformationDiagnoses from './OrderViewInformationDiagnoses';
import OrderViewInformationReferralSource from './OrderViewInformationReferralSource';
import OrderViewInformationSalesRepresentative from './OrderViewInformationSalesRepresentative';

const styles = () => ({
  root: {
    marginTop: 15,
  },
});

const OrderViewInformation = ({
  Patient,
  Facility,
  Vitals,
  Prescriber,
  Diagnosis,
  classes,
  ...otherProps
}) => (
  <Paper className={classes.root}>
    <OrderViewInformationGeneral
      Facility={Facility}
      {...{ 'Transmission Method': otherProps['Transmission Method'] }}
    />
    {Vitals.length > 0 &&
      <OrderViewInformationVitals Vitals={Vitals} />
    }
    {(Prescriber && Prescriber.ID) &&
      <OrderViewInformationPrescriber Prescriber={Prescriber} />
    }
    {Diagnosis.length > 0 &&
      <OrderViewInformationDiagnoses
        Diagnosis={Diagnosis.map((item) => {
          const patientDiagnosis = Patient.Diagnosis.find(patientItem =>
            patientItem.ID === item.ID);
          return patientDiagnosis || item;
        })}
      />
    }
    {(otherProps['Referral Source'] && otherProps['Referral Source'].ID) &&
      <OrderViewInformationReferralSource
        {...{ 'Referral Source': otherProps['Referral Source'] }}
      />
    }
    {otherProps['Sales Representative'].length > 0 &&
      <OrderViewInformationSalesRepresentative
        {...{ 'Sales Representative': otherProps['Sales Representative'] }}
      />
    }
  </Paper>
);

OrderViewInformation.propTypes = {
  'Transmission Method': PropTypes.string.isRequired,
  Patient: PropTypes.shape({
    Diagnosis: PropTypes.arrayOf(PropTypes.shape({
      ID: PropTypes.number.isRequired,
    })).isRequired,
  }).isRequired,
  Facility: PropTypes.shape({
    ID: PropTypes.number,
  }),
  Vitals: PropTypes.arrayOf(PropTypes.shape({
    ID: PropTypes.number,
  })),
  Prescriber: PropTypes.shape({
    ID: PropTypes.number,
  }),
  Diagnosis: PropTypes.arrayOf(PropTypes.shape({
    ID: PropTypes.number.isRequired,
  })),
  'Referral Source': PropTypes.shape({
    ID: PropTypes.number,
  }),
  'Sales Representative': PropTypes.arrayOf(PropTypes.shape({
    ID: PropTypes.number.isRequired,
  })),
  classes: PropTypes.shape({
    root: PropTypes.string.isRequired,
  }).isRequired,
};

OrderViewInformation.defaultProps = {
  Facility: null,
  'Referral Source': null,
  Prescriber: {},
  Vitals: [],
  Diagnosis: [],
  'Sales Representative': [],
};

export default withStyles(styles)(OrderViewInformation);



// WEBPACK FOOTER //
// ./src/components/workflow/OrderViewInformation/OrderViewInformation.js